import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ThemeService } from 'app/shared/services/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-indeterminate-progress-dialog',
  templateUrl: './indeterminate-progress-dialog.component.html',
  styleUrls: ['./indeterminate-progress-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IndeterminateProgressDialogComponent implements OnInit {
  public isDarkTheme: boolean;
  private isDarkThemeSub: Subscription;

  constructor(public readonly themeService: ThemeService) {}

  ngOnInit() {
    this.isDarkThemeSub = this.themeService.isDarkThemeBS.subscribe((isDarkTheme) => {
      this.isDarkTheme = isDarkTheme;
    });
  }

  ngOnDestroy() {
    if (this.isDarkThemeSub) {
      this.isDarkThemeSub.unsubscribe;
    }
  }
}
